import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import KpiText from 'components/text/KpiText';
import TileSubText from 'components/text/TileSubText';
import TileTitle from 'components/text/TileTitle';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const KpiTile: FunctionComponent<Props> = ({
    className = '',
    subtext,
    testId = TEST_ID,
    title,
    value
}) => (
    <Wrapper className={`${className} ${styles.kpiTile}`} testId={testId}>
        <VerticalContainer className={styles.verticalContainer}>
            <TileTitle text={title} />

            {value ? <KpiText text={value} /> : null}

            {subtext ? <TileSubText text={subtext} /> : null}
        </VerticalContainer>
    </Wrapper>
);

export default KpiTile;
